// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/custom.css
 ** module id = 1616
 ** module chunks = 0
 **/